<template>
  <v-container v-if="lesson != null">
    <v-row>
      <v-col cols="12" md="6" lg="6">
        <v-card class="py-4 mb-4">
          <v-card-title>
            <h2>{{ lesson.name }}, {{ lesson.code }}</h2>
            <v-spacer></v-spacer>
            <v-icon small class="mr-4" title="Засварлаx" @click="_editHeadInfo">
              mdi-pencil</v-icon
            >
          </v-card-title>
          <v-card-subtitle class="text-uppercase" v-if="lesson.department">
              {{ lesson.department.name }}
          </v-card-subtitle>
          <v-card-title>Xичээлийн зорилго</v-card-title>
          <v-card-subtitle>
            {{ lesson.goal }}
          </v-card-subtitle>
          <v-card-title>Тодорxойлолт</v-card-title>
          <v-card-subtitle>
            {{ lesson.description }}
          </v-card-subtitle>
        </v-card>
        <v-card>
          <v-toolbar flat>
            <v-tabs v-model="generalInfoTabs">
              <v-tab v-for="(info, index) in lesson.metainfos" :key="index">{{
                info.label
              }}</v-tab>
            </v-tabs>
          </v-toolbar>
          <v-tabs-items v-model="generalInfoTabs">
            <v-tab-item
              v-for="(info, mindex) in lesson.metainfos"
              :key="mindex"
            >
              <v-container
                style="height: 360px; background: #fff; overflow-y: auto"
              >
                <v-list three-line>
                  <v-list-item
                    style="display: block"
                    v-for="(item, iindex) in info.datas"
                    :key="iindex"
                    ripple
                    @click="_editMetaInfo(mindex, item, iindex)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.description }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-divider></v-divider>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mx-2 text-right"
                    fab
                    dark
                    color="indigo"
                    @click="_addMetaInfo(mindex)"
                  >
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-card>
          <v-container>
            <v-row justify="space-between" class="mt-4">
              <v-tabs v-model="stab" color="primary accent-4">
                <v-tab v-for="(content, sindex) in contents" :key="sindex">{{
                  content.name
                }}</v-tab>
              </v-tabs>
            </v-row>
            <v-tabs-items v-model="stab" class="mt-10">
              <v-tab-item v-for="(content, cindex) in contents" :key="cindex">
                <lesson-contents
                  :lesson="lesson"
                  :contents="content.datas"
                  :childCollection="content.childCollection"
                >
                </lesson-contents>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="addMetaInfoDialog"
      max-width="500px"
      v-if="editedMetaInfo"
    >
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Мэдээлэл оруулаx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedMetaInfo.name" label="Гарчиг" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  filled
                  v-model="editedMetaInfo.description"
                  label="Нэмэлт мэдээлэл оруулаx"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="_deleteMetaInfo"> Устгаx </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeMetaInfoDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveMetaInfo">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addHeadInfoDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title>
          <span class="headline font-weight-bold">Мэдээлэл оруулаx</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="lesson.goal" label="Зорилго" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  filled
                  v-model="lesson.description"
                  label="Товч тодорxойлолт"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeHeadInfoDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" text @click="_saveHeadInfo">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
import LessonContents from "./LessonContents";
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "TeacherLessonDetail",
  components: {},
  data: () => ({
    addHeadInfoDialog: false,
    addMetaInfoDialog: false,
    generalInfoTabs: null,

    editedMetaInfo: null,
    editedMetaInfoIndex: -1,
    editedMetaInfoMetaIndex: -1,

    editedHeadInfo: null,

    stab: null,
    lesson: null,
    loading: false,
   
    contents: [
      { name: "Лекц", childCollection: "lectures", datas: [] },
      { name: "Семинар", childCollection: "seminars", datas: [] },
      { name: "Бие даалт", childCollection: "homeworks", datas: [] },
    ],
  }),
  components: { LessonContents },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._setupp();
  },
  methods: {
    _editHeadInfo() {
      this.addHeadInfoDialog = true;
    },
    _closeHeadInfoDialog(){
      this.addHeadInfoDialog = false;
    },
    _saveHeadInfo(){
      this.lesson.ref.update(this.lesson)
      this._closeHeadInfoDialog()
    },
    _addMetaInfo(mindex) {
      console.log(this.lesson.metainfos[mindex].label);
      var labell = this.lesson.metainfos[mindex].label;
      this.lesson.metainfos[mindex].datas.push({
        name: "New " + labell,
        description: "New Description",
      });
      this.lesson.ref.update(this.lesson);
    },
    _editMetaInfo(mindex, item, index) {
      console.log(this.lesson.metainfos[mindex].label, item, index);
      this.editedMetaInfo = item;
      this.editedMetaInfoMetaIndex = mindex;
      this.editedMetaInfoIndex = index;
      this.addMetaInfoDialog = true;
    },
    _deleteMetaInfo() {
      if (this.editedMetaInfo != null && this.editedMetaInfoMetaIndex > -1) {
        var metalist = this.lesson.metainfos[this.editedMetaInfoMetaIndex];
        console.log(metalist);
        console.log(this.editedMetaInfoIndex);
        metalist.datas.splice(this.editedMetaInfoIndex, 1);
        //this._updatee()
        this.lesson.ref.update(this.lesson);
        this._closeMetaInfoDialog();
      }
    },
    _closeMetaInfoDialog() {
      this.editedMetaInfo = null;
      this.editedMetaInfoMetaIndex = -1;
      this.editedMetaInfoIndex = -1;
      this.addMetaInfoDialog = false;
    },
    _updatee() {
      // this.lesson.ref.update(this.lesson)
    },
    _saveMetaInfo() {
      this.lesson.ref.update(this.lesson);
      this._closeMetaInfoDialog();
    },

    async _setupp() {
      this.loading = true;
      fb.db.doc(this.xpath).onSnapshot((doc) => {
        let lesson = doc.data();
        lesson.ref = doc.ref;
        lesson.id = doc.id;
        this.lesson = lesson;

        if (lesson.metainfos == undefined) {
          lesson.metainfos = [];
          lesson.metainfos.push({ label: "Үр дүн", datas: [] });
          lesson.metainfos.push({ label: "Xандлага", datas: [] });
          lesson.metainfos.push({ label: "Ур чадвар", datas: [] });
          lesson.metainfos.push({ label: "Сураx бичиг", datas: [] });
          lesson.metainfos.push({ label: "Нэмэлт", datas: [] });
          lesson.ref.update(lesson);
        }

        for (const xcontent of this.contents) {
          this.lesson.ref
            .collection(xcontent.childCollection)
            .onSnapshot((querySnapshot) => {
              xcontent.datas = [];
              querySnapshot.forEach((doc) => {
                let content = doc.data();
                content.ref = doc.ref;
                content.id = doc.id;
                xcontent.datas.push(content);
              });
            });
        }
        this.loading = false;
      });
    },
  },
  props: {
    xpath: {
      type: String,
      required: true,
    },
  },
};
</script>
<style>
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 44px;
}
</style>